import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import {Repository} from 'typeorm';
import { RmToleranceDTO } from './dto/rm-tolerance.dto';
import { RmTolerance } from './rm-tolerance.entity';
import { RmToleranceAdapter } from './dto/rm-tolerance.adapter';
import { ErrorResponse, UserRequestDto } from '@gtpl/shared-models/common-models';
import {RmToleranceRequest} from './dto/rm-tolerance.request';
import { AllRmToleranceResponse, RmToleranceResponse } from '@gtpl/shared-models/raw-material-procurement';
import moment = require('moment');
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';

@Injectable()
export class RmToleranceService {
    constructor(
      private logService:LogsService,
        @InjectRepository(RmTolerance) private rmToleranceRepository: Repository<RmTolerance>,
        private RmToleranceAdapter: RmToleranceAdapter,
      ) { }

      async createRmTolerance(rmToleranceDTO:RmToleranceDTO, isUpdate: boolean,request:Request): Promise<RmToleranceResponse> {
          try {
        let previousValue;
        if (!isUpdate) {
            const rmToleranceEntity = await this.getRmTolerance(rmToleranceDTO.date);
          if (rmToleranceEntity) {
            throw new RmToleranceResponse(false,11104, 'Rm Tolerance already exists');
          }
        }
        else{
            const previous = await this.rmToleranceRepository.findOne({where:{rmToleranceId:rmToleranceDTO.rmToleranceId}})
            previousValue=previous.looseShell+','+previous.softShell+','+previous.fungus;
            const rmToleranceEntity = await this.getRmTolerance(rmToleranceDTO.date);
            if (rmToleranceEntity) {
                if(rmToleranceEntity.rmToleranceId!=rmToleranceDTO.rmToleranceId){
                    throw new RmToleranceResponse(false,11104, 'Rm Tolerance  already exists');
                }
            }
        }
        const convertedrmToleranceEntity:RmTolerance = this.RmToleranceAdapter.convertDtoToEntity(rmToleranceDTO,isUpdate);
        const savedrmToleranceEntity: RmTolerance = await this.rmToleranceRepository.save(convertedrmToleranceEntity);
        const savedrmToleranceDTO: RmToleranceDTO = this.RmToleranceAdapter.convertEntityToDto(savedrmToleranceEntity);
       
         if (savedrmToleranceDTO) {
            const present = savedrmToleranceDTO.looseShell+','+savedrmToleranceDTO.softShell+','+savedrmToleranceDTO.fungus;
          const response = new RmToleranceResponse(true,isUpdate ? 11100 : 11101,isUpdate? 'Rm Tolerance date Updated Successfully':'Rm Tolerance Created Successfully',savedrmToleranceDTO);
          const name=isUpdate?'updated':'created'
          const userName = isUpdate ? savedrmToleranceDTO.updatedUser : savedrmToleranceDTO.createdUser
             const displayValue = isUpdate? 'Rm Tolerance date Updated Successfully':'Rm Tolerance Created Successfully'
        const newLogDto = new LogsDto(1,name, 'RmTolerance', savedrmToleranceDTO.rmToleranceId, true,displayValue,userName,previousValue,present)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
          return response;
        } else {
          throw new RmToleranceResponse(false,11106,'Rm Tolerance saved but issue while transforming into DTO');
        }
      }
      catch (error) {
        return error;
      }
    }

    /**
     * gets all Rm Tolerance details  
     * @returns all the Rm tolerance details .
     */
    // @LogActions({ isAsync: true })
    async getAllRmTolerance(req?:UserRequestDto): Promise<AllRmToleranceResponse> {  
        try {
            const rmToleranceDTO: RmToleranceDTO[] = [];
           
            const rmToleranceEntities: RmTolerance[] = await this.rmToleranceRepository.find({
                order: { date: "ASC" },
            });
            
            if (rmToleranceEntities.length>0) {
                rmToleranceEntities.forEach(RmToleranceEntity => {
                const convertedrmToleranceDTO:RmToleranceDTO = this.RmToleranceAdapter.convertEntityToDto(RmToleranceEntity);
                rmToleranceDTO.push(convertedrmToleranceDTO);
                });
                const response = new AllRmToleranceResponse(true, 11208, "Rm Tolerance retrieved successfully", rmToleranceDTO);
                if(req?.createdUser){
                    const newLogDto = new LogsDto(1,'view', 'RmTolerance', 0, true,"Rm Tolerance retrieved successfully" ,req.createdUser,'','')
                    let res = await this.logService.createLog(newLogDto);
                    console.log(res);
                }

                return response;
            } else {
                //   console.log('yest')
                throw new RmToleranceResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getRmTolerance(date: Date): Promise<RmTolerance> {
        
            const response = await this.rmToleranceRepository.findOne({
            where: {date: date},
            });
            console.log(response,'?????????');
            if (response) {
            return response;
            } else {
            return null;
            }
        }

    /**
     * It deactivates value    Rm tolerance   
     * @param itemReq      Rm tolerance as string
     * @returns true or false
     */
    // @LogActions({isAsync: true})
    async activateOrDeactivateRmTolerance(rmToleranceReq: RmToleranceRequest): Promise<RmToleranceResponse> {
        try {
            const rmToleranceExists = await this.getRmToleranceById(rmToleranceReq.rmToleranceId);
            if (rmToleranceExists) {
                if (rmToleranceReq.versionFlag !== rmToleranceExists.versionFlag) {
                    throw new RmToleranceResponse(false,10113, 'Someone updated the current RmTolerance information.Refresh and try again');
                } else {
                    
                        const rmToleranceStatus =  await this.rmToleranceRepository.update(
                            { rmToleranceId: rmToleranceReq.rmToleranceId },
                            { isActive: rmToleranceReq.isActive,updatedUser: rmToleranceReq.updatedUser });
                       
                        if (rmToleranceExists.isActive) {
                            if (rmToleranceStatus.affected) {
                                const rmToleranceResponse: RmToleranceResponse = new RmToleranceResponse(true, 10115, 'Rm Tolerance is de-activated successfully');
                                return rmToleranceResponse;
                            } else {
                                throw new RmToleranceResponse(false,10111, 'Rm Tolerance is already deactivated');
                            }
                        } else {
                            if (rmToleranceStatus.affected) {
                                const rmToleranceResponse: RmToleranceResponse = new RmToleranceResponse(true, 10114, 'Rm Tolerance is activated successfully');
                                return rmToleranceResponse;
                            } else {
                                throw new RmToleranceResponse(false,10112, 'Rm Tolerance is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new RmToleranceResponse(false,99998, 'No Records Found');
            }
        } catch (err) {
            return err;
        }
    }

    async getRmToleranceById(rmToleranceId: number): Promise<RmTolerance> {
    //  console.log(employeeId);
        const response = await this.rmToleranceRepository.findOne({
        where: {rmToleranceId: rmToleranceId},
        });
        
        if (response) {
        return response;
        } else {
        return null;
        }
    }
}
